export type OptionValue = string | number;

export interface Option {
  label: string;
  value: OptionValue;
}

interface SelectProps {
  name: string;
  options: Option[];
  value: OptionValue;
  onSelectChange: (value: OptionValue) => void;
}

export const Select: React.FC<SelectProps> = ({ name, options, value, onSelectChange }) => {
  return (
    <select
      id={name}
      name={name}
      value={value}
      onChange={(e) => onSelectChange(e.target.value)}
      className="select select-bordered select-secondary select-sm max-w-xs"
    >
      {options.map((option) => (
        <option key={`${name}-${option.value}`} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};
